import { render, staticRenderFns } from "./itemForm.vue?vue&type=template&id=16a924c9&scoped=true&"
import script from "./itemForm.vue?vue&type=script&lang=js&"
export * from "./itemForm.vue?vue&type=script&lang=js&"
import style0 from "./itemForm.vue?vue&type=style&index=0&id=16a924c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a924c9",
  null
  
)

export default component.exports